import axios from 'axios'
import { serviceUtils } from '../helpers/serviceUtils'

const responseHandler = (data) => {
    if (!data || data.date === '') {
        throw new Error(data)
    }
}

const errorHandler = (err) => {
    // eslint-disable-next-line
    return Promise.reject(err)
}

const getPaises = () => {
    return serviceUtils.get(
        serviceUtils.baseUrl(`getpaises`),
        null,
        null,
        {
            response: responseHandler,
            error: errorHandler,
        },
    )
}

const getPosicoes = () => {
    return serviceUtils.get(
        serviceUtils.baseUrl(`getposicoes`),
        null,
        null,
        {
            response: responseHandler,
            error: errorHandler,
        },
    )
}

const getSubPosicoes = () => {
    return serviceUtils.get(
        serviceUtils.baseUrl(`getsubposicoes`),
        null,
        null,
        {
            response: responseHandler,
            error: errorHandler,
        },
    )
}

const getPes = () => {
    return serviceUtils.get(
        serviceUtils.baseUrl(`getpes`),
        null,
        null,
        {
            response: responseHandler,
            error: errorHandler,
        },
    )
}

const getModalidades = () => {
    return serviceUtils.get(
        serviceUtils.baseUrl(`getmodalidades`),
        null,
        null,
        {
            response: responseHandler,
            error: errorHandler,
        },
    )
}

const prepareUploadPhoto = (playerID, photo) => {
    const formData = new FormData()
    formData.append('foto', photo)
    formData.append('fk_jogador', playerID)
  
    return axios.post(
      `${process.env.REACT_APP_UPLOAD_SERVER}`,
      formData,
      {
        'content-type': 'multipart/form-data',
      },
    )
  }
  
  function postUploadPhoto(playerID, photoUrl) {
    return axios.post(
      serviceUtils.baseUrl('uploadImage'),
      {
        ador: playerID,
        foto: photoUrl,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  }
  
  function deleteUploadPhoto(playerID, path) {
    const localPath = path.replace(process.env.REACT_APP_UPLOAD_SERVER + '/api/upload/', '')
  
    return axios.delete(
      `${process.env.REACT_APP_UPLOAD_SERVER}?path=${localPath}&fk_jogador=${playerID}`,
      {
        'content-type': 'multipart/form-data',
      },
    )
  }

const saveForm = (body, hash) => {
    return serviceUtils.post(
        serviceUtils.baseUrl('setMyCardPlayerInfo'),
        { "Content-type": "application/json" },
        body,
        {
            response: responseHandler,
            error: errorHandler,
        },
        hash
    )
}

export const formService = {
    getPaises,
    getPosicoes,
    getSubPosicoes,
    getPes,
    getModalidades,
    saveForm,
    prepareUploadPhoto,
    postUploadPhoto,
    deleteUploadPhoto,
}